import { useEffect, useState } from "react";
import PageShell from "@/components/PageShell";
import { useLang } from "@/context/LanguageContext";
import { api, resolveImage } from "@/lib/api";
import { pick } from "@/i18n/translations";
import { WhatsappCTA, NewsletterSection, LocationSection } from "@/pages/Home";

export default function Categories() {
    const { t, lang } = useLang();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        api.get("/categories").then((r) => setCategories(r.data || [])).catch(() => {});
    }, []);

    return (
        <PageShell>
            <section className="relative bg-brand-green text-white overflow-hidden">
                <div className="absolute inset-0 grainy opacity-50" />
                <div className="container-x relative py-20 md:py-24">
                    <div className="eyebrow text-brand-yellow">{t.categories.eyebrow}</div>
                    <h1 className="mt-4 font-display font-extrabold text-4xl md:text-6xl lg:text-7xl text-balance max-w-3xl">{t.categories.title}</h1>
                    <p className="mt-5 text-white/80 max-w-2xl text-lg">{t.categories.subtitle}</p>
                </div>
            </section>

            <section className="container-x py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {categories.map((c, i) => (
                        <article key={c.id || c.slug} className="group relative overflow-hidden rounded-3xl bg-white border border-black/5 shadow-[0_10px_40px_-20px_rgba(17,17,17,0.18)] transition-transform hover:-translate-y-1" data-testid={`category-detail-${c.slug}`}>
                            <div className="relative aspect-[4/3] overflow-hidden">
                                <img src={resolveImage(c.image_url)} alt={pick(c.name, lang)} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                                <div className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-brand-charcoal">
                                    0{i + 1}
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="font-display text-2xl font-semibold">{pick(c.name, lang)}</div>
                                <p className="mt-2 text-sm text-brand-charcoal/70">{pick(c.description, lang)}</p>
                                <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand-cream-dark/60 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-brand-green">
                                    Im Markt verfügbar
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <LocationSection />
            <WhatsappCTA />
            <NewsletterSection />
        </PageShell>
    );
}
